import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import { colors, typography } from '../../styles';


const styles = css`
  .Banner_Wrapper {
    margin-bottom:30px;
    border-top:1px solid white;
  }
  .Banner_Result {
    max-width: 1600px;
    margin:0 auto;
    display:flex;
    flex-flow:row-reverse wrap;
    justify-content: flex-start;
  }
  .Banner_Media {
    width:100%;
    position: relative;
    display:flex;
    flex-flow:column wrap;
    justify-content:center;
    @media (min-width: 992px) {
      width:60%;
      padding:0 10px;
    }
    img {
      width:100%;
      max-width:100%;
      height:auto;
    }
  }
  .Banner_Media_Label {
    display:none;
    font:700 16px/1 ${typography.SansSerif};
    @media (min-width: 992px) {
      display:block;
      position:absolute;
      bottom:20px;
      left:20px;
      color:  white;
    }
  }
  .Banner_Content {
    display:flex;
    flex-flow:column nowrap;
    justify-content: center;
    text-align: left;
    width:100%;
    margin-bottom:30px;
    padding:0 20px;
    margin-top:-39px;
    z-index: 1;
    position: relative;
    @media (min-width: 992px) {
      width:40%;
      margin:0;
      padding:80px 20px;
    }
  }
  .Banner_preTitle {
    @media (min-width: 992px) {
    }
  }
  .Banner_Title {
    color:  white;
    font:700 18px/1 ${typography.SansSerif};
    padding:20px 30px;
    border:1px solid ${colors.color1};
    text-transform: uppercase;
    display: inline-block;
    margin-bottom: 24px;
    background: ${colors.color1};
    @media (min-width: 992px) {
      font:700 24px/1 ${typography.SansSerif};
    }
  }
  .Banner_postTitle {
    font:700 24px/1.4 ${typography.SansSerif};
    color:  ${colors.color1};
    display:block;
    width:100%;
  }
  .Banner_Body {
    font:400 16px/34px ${typography.SansSerif};
    color:  ${colors.color5};
    background: white;
    @media (min-width: 992px) {
      font:400 18px/40px ${typography.SansSerif};
      padding: 20px 20px 40px 0;
    }
  }
  .btn-arrow {
    font:700 18px/1 ${typography.SansSerif};
    color:  ${colors.color1};
    text-transform:uppercase;
    letter-spacing: 2px;
    z-index: 1;
    display:block;
    padding-top:20px;
  }
`;

function HomeShowcase({ page }) {
  return (
    <div className={styles}>
      <div className="Banner_Wrapper">
        <div className="Banner_Result">
          {/* <div className="Banner_Media" style={{ backgroundImage:
             `url('${buildThumbnailUrl(get(page, 'home_content[0].image.contentUrl'),
              { width: 1200, height: 1200 })}')` }} >
            <img src={page.home_content[0].image.contentUrl} alt="" />
            <span className="Banner_Media_Label">{page.home_content[0].title}</span>
          </div> */}
          <div className="Banner_Media">
            <img src={page.home_content[0].image.contentUrl} alt="" />
          </div>
          <div className="Banner_Content">
            <h3>
              <span className="Banner_Title">{page.home_content[0].pre_title}</span>
              <span className="Banner_postTitle">{page.home_content[0].title}</span>
            </h3>
            <div className="Banner_Body">
              <div dangerouslySetInnerHTML={SanitizeHtml(get(page, 'home_content[0].body'))} />
              <Link name="about-us" className="btn-arrow">{page.home_content[0].button} <img src="/images/icon-right-arrow.png" alt="" /></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HomeShowcase.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'home_page',
})(HomeShowcase);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomeContents.js